import { Component } from '@angular/core';
import { ORCIDPeerReviewEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Peer Reviews') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-orcidpeerreview-form',
    templateUrl: './orcidpeerreview.form.component.html'
})
export class ORCIDPeerReviewFormComponent extends BaseFormComponent {
    public record!: ORCIDPeerReviewEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

